import React, { forwardRef } from 'react';

import MUISlide, { SlideProps as MUISlideProps } from '@material-ui/core/Slide';

interface SlideProps extends MUISlideProps {}

const Slide = forwardRef<HTMLDivElement, SlideProps>((props, ref) => {
  return <MUISlide {...props} ref={ref} />;
});

Slide.displayName = 'Slide';

export default Slide;
